import type { MaybeRefOrGetter } from "vue";
import { computed, toValue } from "vue";

export function useArticleJsonLd(
  page: MaybeRefOrGetter<Record<string, any> | null | undefined>,
  path: MaybeRefOrGetter<string>,
) {
  const { siteUrl } = useRuntimeConfig().public;
  const site = useSite();

  useJsonLdHead(
    computed(() => {
      const pageValue = toValue(page);
      const pathValue = toValue(path);
      if (!pageValue) return null;
      return withBreadcrumbJsonLd(
        buildArticleJsonLd(pageValue, pathValue, siteUrl, site.value),
        pathValue,
        siteUrl,
      );
    }),
  );
}
